import {isTokenExpired} from 'helpers/utilities/token-helpers';

const tokenKey = 'token';

class AuthService {
  constructor() {}

  /**
   * Checks if an unexpired JSON web token is present in local storage.
   *
   * @method checkToken
   */
  checkToken() {
    const token = this.getToken();

    if (!token || isTokenExpired(token)) {
      this.removeToken();
      return false;
    }

    return true;
  }

  getToken(token) {
    return localStorage.getItem(tokenKey);
  }

  setToken(token) {
    localStorage.setItem(tokenKey, token);
  }

  removeToken() {
    localStorage.removeItem(tokenKey);
  }
}

const authService = new AuthService();
export default authService;



// WEBPACK FOOTER //
// ./src/client/services/auth-service.js